import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BusinessType } from '../models/business-type.model';
import { FirestoreService } from './firestore.service';

const itemCollection = 'business-types';

@Injectable({
  providedIn: 'root',
})
export class BusinessTypesService {
  private firestore = inject(FirestoreService);

  get(guid: string): Observable<BusinessType> {
    if (guid == null) {
      return of(null);
    }
    return this.firestore.get<BusinessType>(itemCollection, guid);
  }

  getList() {
    return this.firestore.getList<BusinessType>(itemCollection);
  }
}
